<style>
.bg-primary {
  background-color: #2b4e8a !important;
}
.browse {
  background-color: #0d86ff;
  color: white;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      RPL Lainnya
      <Button
        class="btn btn-md btn-dark px-4 text-white py-2 ml-auto"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <form id="form-data" @submit.prevent="postData">
      <div class="card-body">
        <!-- Form Tambah Workshop -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">RPL Lainnya</div>
          <div class="card-body" id="coba">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="nama" class="font-weight-bold">Nama</label>
                <input
                  type="text"
                  class="form-control"
                  id="nama"
                  required
                  v-model="formData.namaRpl"
                  placeholder="Masukkan Nama RPL"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="level" class="font-weight-bold">Level</label>
                <multiselect
                  label="namaLevel"
                  id="selectlevel"
                  placeholder="Pilih Level"
                  @input="(value) => pilihLevel(value)"
                  v-model="multi_master_level"
                  :options="optionMasterLevel"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-show="validation.level">
                  Level Harus Dipilih
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="kapasitas" class="font-weight-bold">Kapasitas</label>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  id="kapasitas"
                  required
                  v-model="formData.kapasitas"
                  placeholder="Masukkan Kapasitas"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="tgl" class="font-weight-bold">Tanggal Dimulai</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control border-right-0"
                    id="tgl"
                    required
                    v-model="formData.tanggalDimulai"
                    placeholder="Pilh Tanggal"
                  />
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for="tgl_akhir" class="font-weight-bold">Tanggal Berakhir</label>
                <div class="input-group">
                  <input
                    type="date"
                    class="form-control border-right-0"
                    id="tgl_akhir"
                    required
                    v-model="formData.tanggalBerakhir"
                    placeholder="Pilh Tanggal"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="lokasi" class="font-weight-bold">Lokasi</label>
                <input
                  type="text"
                  class="form-control"
                  id="lokasi"
                  required
                  v-model="formData.lokasi"
                  placeholder="Masukkan Lokasi RPL"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="pos" class="font-weight-bold">Kota / Kabupaten</label>
                <multiselect
                  label="name"
                  placeholder="Pilih Kota/Kab"
                  id="kotaKab"
                  @select="updateSelect"
                  v-model="datakotakab"
                  :options="optionKotaKab"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-show="validation.idKotaKab">
                  Kota / Kabupaten Harus Dipilih
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Tambah Workshop -->

        <!-- Form Instruktur -->
        <div class="card border-0 shadow p-2" id="divinstruktur">
          <div class="card-header bg-white text-muted h4">Instruktur</div>
          <div class="card-body">
            <div
              class="form-row"
              v-for="(input,k) in formData.instrukturSertifikasiRplRequest"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="intruktur" class="font-weight-bold">Instruktur</label>
                <multiselect
                  label="nama"
                  placeholder="Pilih Instruktur"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihInstruktur(value,k)"
                  :options="instruktur"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="input.invalid_instruktur">
                  Instruktur Harus Dipilih.
                </div>
              </div>
              <div class="col-2 d-flex align-items-center mt-2">
                <div
                  class="btn btn-sm btn-success ml-2"
                  @click="add(k)"
                  v-show="k == formData.instrukturSertifikasiRplRequest.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2"
                  @click="remove(k)"
                  v-show="k || ( !k && formData.instrukturSertifikasiRplRequest.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Instruktur -->

        <!-- Form Mata Ujian -->
        <div class="card border-0 shadow p-2" id="divmatauji">
          <div class="card-header bg-white text-muted h4">Mata Ujian</div>
          <div class="card-body">
            <form>
              <div
                class="form-row"
                v-for="(input,k) in formData.sertifikasiRplMataUjiRequest"
                :key="k"
              >
                <div class="form-group col-md-10">
                  <label for="mata_uji" class="font-weight-bold">Mata Ujian</label>
                  <multiselect
                    label="namaMataUji"
                    placeholder="Pilih Mata Uji"
                    v-model="input.modelMultiSelect"
                    required
                    @input="(value) => pilihMataUji(value,k)"
                    :options="optionMasterMataUji"
                  ></multiselect>
                  <div 
                    class="text-danger" 
                    v-if="input.invalid_mata_uji">
                    Mata Uji Harus Dipilih.
                  </div>
                </div>

                <div class="col-2 d-flex align-items-center mt-2">
                  <div
                    class="btn btn-sm btn-success ml-2"
                    @click="addss(k)"
                    v-show="k == formData.sertifikasiRplMataUjiRequest.length-1"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </div>
                  <div
                    class="btn btn-sm btn-danger ml-2"
                    @click="removess(k)"
                    v-show="k || ( !k && formData.sertifikasiRplMataUjiRequest.length > 1)"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--End Form Mata Ujian -->

        <!-- Form Mata Ujian -->
        <div class="card border-0 shadow p-2">
          <div class="card-header bg-white text-muted h4">Biaya RPL</div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for class="font-weight-bold">Biaya Pendaftaran</label>
                <div class="input-group mb-3">
                  <vue-autonumeric
                    required
                    class="form-control"
                    :options="{
                    minimumValue: '0'
                  }"
                    v-model="formData.biaya"
                  ></vue-autonumeric>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for class="font-weight-bold">Biaya Mengulang</label>
                <div class="input-group mb-6">
                  <vue-autonumeric
                    required
                    class="form-control"
                    :options="{
                     minimumValue: '0'
                    }"
                    v-model="formData.biayaMengulang"
                  ></vue-autonumeric>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--End Form Mata Ujian -->

        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2" id="divdokumen">
          <div class="card-header bg-white text-muted h4">Dokumen Persyaratan</div>
          <div class="card-body">
            <div
              class="form-row"
              v-for="(input,k) in formData.dokumenPendukungSertifikasiRplRequest"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="kode_dok" class="font-weight-bold">Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumen(value,k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="input.invalid_dokumen">
                  Dokumen Harus Dipilih.
                </div>
              </div>

              <div class="col-2 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="adds(k)"
                  v-show="k == formData.dokumenPendukungSertifikasiRplRequest.length-1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="removes(k)"
                  v-show="k || ( !k && formData.dokumenPendukungSertifikasiRplRequest.length > 1)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Form Dokumen Upload -->

        <!-- Form Dokumen Upload -->
        <div class="card border-0 shadow p-2" id="divpenerbitan">
          <div class="card-header bg-white text-muted h4">
            Dokumen Persyaratan Penerbitan Sertifikat
          </div>
          <div class="card-body">
            <!-- <form> -->
            <div
              class="form-row"
              v-for="(input, k) in formData.dokumenPersyaratanSertifikat"
              :key="k"
            >
              <div class="form-group col-md-10">
                <label for="nama_dok" class="font-weight-bold">Dokumen</label>
                <multiselect
                  label="namaDokumen"
                  placeholder="Pilih Dokumen"
                  v-model="input.modelMultiSelect"
                  required
                  @input="(value) => pilihDokumenPenerbitan(value, k)"
                  :options="optionMasterDokumen"
                ></multiselect>
                <div 
                  class="text-danger" 
                  v-if="input.invalid_dokumen">
                  Dokumen Pendukung Harus Dipilih.
                </div>
              </div>

              <div class="col-1 d-flex align-items-center">
                <div
                  class="btn btn-sm btn-success ml-2 mt-2"
                  @click="add_dok_sertifikat(k)"
                  v-show="k == formData.dokumenPersyaratanSertifikat.length - 1"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="btn btn-sm btn-danger ml-2 mt-2"
                  @click="remove_dok_sertifikat(k)"
                  v-show="
                    k ||
                    (!k && formData.dokumenPersyaratanSertifikat.length > 1)
                  "
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
        <!-- End Form Dokumen Upload -->

        <CCol sm="6">
          <label for class="font-weight-bold">Status</label>
          <br />
          <div class="d-flex align-items-center">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                name="status"
                id="aktif"
                required
                v-model="formData.status"
                :value="'1'"
              />
              <label class="custom-control-label" for="aktif">Aktif</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                name="status"
                id="tidak_aktif"
                required
                v-model="formData.status"
                :value="'0'"
              />
              <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
            </div>
          </div>
        </CCol>
        <!-- End Form Dokumen Upload -->
      </div>
      <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3 pt-0">
        <!-- <router-link to="/sertifikasi/master-rpl-workshop">
        <Button class="btn btn-md btn-danger px-4 py-2 mr-3" color="danger">Tutup</Button>
        </router-link>-->
        <!-- <router-link to="/sertifikasi/master-rpl-workshop"> -->
        <Button
          class="btn btn-md btn-success float-right px-4 py-2 mb-3"
          type="submit"
          color="success"
        >Simpan</Button>
        <!-- </router-link> -->
      </div>
    </form>
  </div>
</template>
<script>
import RplWorkshopService from "../../../../services/sertifikasi/master-rpl-workshop.service";
import LevelService from "../../../../services/datamaster/level.service";
import AutoNumeric from "../../../../../node_modules/autonumeric/src/main";
import VueAutonumeric from "../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric";
import RplInstrukturService from "../../../../services/sertifikasi/master-rpl-instruktur.service";
import MasterMataUjiService from "../../../../services/sertifikasi/mata-uji.service";
import KotaKabupatenService from "../../../../services/datamaster/kota-kabupaten.service";
import { MasterDokumen } from "../../../../mixins/master/MasterDokumen";
import { Level } from "../../../../mixins/master/Level";
import { AlertUtils } from "../../../../mixins/AlertUtils";
import { Location } from "../../../../mixins/lokasi/Location";
import { MataUji } from "../../../../mixins/master/MataUji";

export default {
  mixins: [MasterDokumen, Level, AlertUtils, Location, MataUji],
  data() {
    return {
      validation : {
        level : false,
        idKotaKab : false
      },
      datakotakab: "",
      KotaKab: [],
      currentPage: 0,
      instruktur: [],
      mataUji: [],
      levelPeruntukan: [],
      formData: {
        instrukturSertifikasiRplRequest: [
          {
            idInstrukturRpl: "",
            instruktur: "",
            keterangan: "",
            nilai: "",
            invalid_instruktur : false,

          },
        ],
        dokumenPendukungSertifikasiRplRequest: [
          {
            kodeDokumen: "",
            namaDokumen: "",
            idMasterDokumenPendukung: "",
            contohDokumen: "",
            statusUpdateFile: "",
            modelMultiSelect: [],
            fileName: "",
            invalid_dokumen : false,

          },
        ],
        dokumenPersyaratanSertifikat: [
          {
            idDokumenPendukung : "",
            idMasterDokumen: "",
            invalid_dokumen : false,
            modelMultiSelect: [],
          },
        ],
        dokumenPersyaratanSertifikat: [
      {
        idDokumenPendukung: "",
        idMasterDokumen: "",
        invalid_dokumen: false,
        modelMultiSelect: [],
      },
    ],
        sertifikasiRplMataUjiRequest: [
          {
            idMasterMataUji: "",
            deskripsi: "",
            batasNilai: "",
            
          },
        ],
        idKotaKab: "",
        kodeRpl: "",
        namaRpl: "",
        idLevel: "",
        biaya: 0,
        biayaMengulang: 0,
        tanggalDimulai: "",
        tanggalBerakhir: "",
        lokasi: "",
        kapasitas: "",
        kategori: "",
        status: "",
        biayaPerMataUji: 0,
        idKategoriRpl: "990b7ca8-88bc-490e-862d-8c65e0e0f123",
      },
    };
  },
  components: {
    VueAutonumeric,
  },
  mounted() {
    this.getInstrukturRpl("0");
    this.getAllLevel();
    this.getAllMataUji();
    this.getAllKotaKab();
    this.getAllDokumen();
  },

  methods: {
    pilihDokumenPenerbitan(value, k) {
      if(value.idMasterDokumen != null) {
        this.formData.dokumenPersyaratanSertifikat[k].invalid_dokumen = false
      }

      var data = value.idMasterDokumen;

      for (
        let index = 0;
        index < this.formData.dokumenPersyaratanSertifikat.length;
        index++
      ) {

        var idMasterDokumen = this.formData.dokumenPersyaratanSertifikat[index].idMasterDokumen;
        var idSelectMasterDokumen = data

        if (idMasterDokumen == idSelectMasterDokumen) {
          this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
          return false;
        }
      }

      this.formData.dokumenPersyaratanSertifikat[k].idMasterDokumen = value.idMasterDokumen;
    },
    pilihLevel(event) {
      var vm = this;
      if(event.idLevelAnggota != null) {
        this.validation.level = false
        this.formData.idLevel = event.idLevelAnggota;
        // comment console console.log(event.idLevelAnggota)
      } else {
        this.formData.idLevel = "";
      }
    },
    
    pilihDokumen(value, k) {
      if(value.idMasterDokumen != null) {
        this.formData.dokumenPendukungSertifikasiRplRequest[k].invalid_dokumen = false
        for (
          let index = 0;
          index < this.formData.dokumenPendukungSertifikasiRplRequest.length;
          index++
        ) {
          var idMasterDokumen = this.formData.dokumenPendukungSertifikasiRplRequest[index].idMasterDokumen;
          var idSelectMasterDokumen = value.idMasterDokumen;
          if (idMasterDokumen == idSelectMasterDokumen) {
            this.alertError("Tidak Boleh Ada Dokumen Yang Sama");
            return false;
          }
        }
        this.formData.dokumenPendukungSertifikasiRplRequest[
          k
        ].idMasterDokumenPendukung = value.idMasterDokumen;
      } else {
        this.formData.dokumenPendukungSertifikasiRplRequest[k].idMasterDokumenPendukung = ""
      }
    },

    updateSelect(value) {
      var vm = this;
      if(value.id_kota_kab != null) {
        this.validation.idKotaKab = false
        // comment console console.log(value.id_kota_kab)
        vm.formData.idKotaKab = value.id_kota_kab;
      } else {
        vm.formData.idKotaKab = "";
      }
    },

    pilihMataUji(event, k) {
      if(event.idMasterMataUji != null) {
        this.formData.sertifikasiRplMataUjiRequest[k].invalid_mata_uji = false
      }

      var data = event.idMasterMataUji

      for (
        let index = 0;
        index < this.formData.sertifikasiRplMataUjiRequest.length;
        index++
      ) {
        var idMasterMataUji = this.formData.sertifikasiRplMataUjiRequest[index].idMasterMataUji;
        var idSelectMataUji = data;
        if (idMasterMataUji == idSelectMataUji) {
          this.alertError("Tidak Boleh Ada Mata Uji Yang Sama");
          return false;
        }
      }
      this.formData.sertifikasiRplMataUjiRequest[k].idMasterMataUji = data;
      this.formData.sertifikasiRplMataUjiRequest[k].batasNilai = event.nilaiMinimum;
      // comment console console.log(k);
    },

    postData() {
      if(this.formData.idLevel == "") {
        var container = this.$el.querySelector("#selectlevel");
        container.scrollIntoView()
        container.focus()
        this.validation.level = true
        return false
      } else {
        this.validation.level = false
      }

      /**
       * Validasi Kota Kab
       */
      if(this.formData.idKotaKab == "") {
        var container = this.$el.querySelector("#kotaKab");
        container.scrollIntoView()
        container.focus()
        this.validation.idKotaKab = true
        return false
      } else {
        this.validation.idKotaKab = false
      }

      // idKotaKab

      /**
       * Validasi Mata Uji
       */
      var status_invalid = 0;

      this.formData.sertifikasiRplMataUjiRequest.filter(function(element, index) {
        if(element.idMasterMataUji == '') {
          element.invalid_mata_uji = true;
          status_invalid += 1;
        }  
      });

      if(status_invalid > 0) {
        var container = this.$el.querySelector("#divmatauji");
        container.scrollIntoView()
        return false
      }

      /**
       * Validasi Instruktrur
       */
      var status_invalid_instruktur = 0;

      this.formData.instrukturSertifikasiRplRequest.filter(function(element, index) {
        if(element.idInstrukturRpl == '') {
          element.invalid_instruktur = true;
          status_invalid_instruktur += 1;
        }  
      });

      if(status_invalid_instruktur > 0) {
        var container = this.$el.querySelector("#divinstruktur");
        container.scrollIntoView()
        return false
      }

      /**
       * Validasi Dokumen Penerbitan Sertifikat
       */
      var status_invalid_dokumen_penerbitan = 0;
      this.formData.dokumenPersyaratanSertifikat.filter(function(element, index) {
        if(element.idMasterDokumen == '') {
          element.invalid_dokumen = true;
          status_invalid_dokumen_penerbitan += 1;
        }  
      });
     
      if(status_invalid_dokumen_penerbitan > 0) {
        var container = this.$el.querySelector("#divpenerbitan");
        container.scrollIntoView()
        return false
      }

      

      /**
       * Validasi Dokumen
       */
      var status_invalid_dokumen = 0;
      this.formData.dokumenPendukungSertifikasiRplRequest.filter(function(element, index) {
        if(element.idMasterDokumenPendukung == '') {
          element.invalid_dokumen = true;
          status_invalid_dokumen += 1;
        }  
      });
     
      if(status_invalid_dokumen > 0) {
        var container = this.$el.querySelector("#divdokumen");
        container.scrollIntoView()
        return false
      }

      this.insertData(this.formData);
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      for (
        let index = 0;
        index < formData.instrukturSertifikasiRplRequest.length;
        index++
      ) {
        var idInstrukturRpl = this.formData.instrukturSertifikasiRplRequest[
          index
        ].idInstrukturRpl;
        for (
          let indexTwo = index + 1;
          indexTwo < formData.instrukturSertifikasiRplRequest.length;
          indexTwo++
        ) {
          if (
            formData.instrukturSertifikasiRplRequest[index].idInstrukturRpl ==
            formData.instrukturSertifikasiRplRequest[indexTwo].idInstrukturRpl
          ) {
            this.alertError("Tidak Boleh Instruktur Yang Sama");

            return false;
          }
        }
      }

      for (
        let mataUji = 0;
        mataUji < formData.sertifikasiRplMataUjiRequest.length;
        mataUji++
      ) {
        for (
          let mataUjiTwo = mataUji + 1;
          mataUjiTwo < formData.sertifikasiRplMataUjiRequest.length;
          mataUjiTwo++
        ) {
          if (
            formData.sertifikasiRplMataUjiRequest[mataUji].idMasterMataUji ==
            formData.sertifikasiRplMataUjiRequest[mataUjiTwo].idMasterMataUji
          ) {
            this.alertError("Tidak Boleh Mata Uji Yang Sama");

            return false;
          }
        }
      }

      for (
        let uploadDok = 0;
        uploadDok < formData.dokumenPendukungSertifikasiRplRequest.length;
        uploadDok++
      ) {
        for (
          let uploadDokTwo = uploadDok + 1;
          uploadDokTwo < formData.dokumenPendukungSertifikasiRplRequest.length;
          uploadDokTwo++
        ) {
          if (
            formData.dokumenPendukungSertifikasiRplRequest[uploadDok]
              .idMasterDokumenPendukung ==
            formData.dokumenPendukungSertifikasiRplRequest[uploadDokTwo]
              .idMasterDokumenPendukung
          ) {
            this.$swal.fire({
              title: "Peringatan!",
              text: "Kode Dokumen Tidak Boleh Sama",
              icon: "error",
              showCancelButton: true,
            });

            return false;
          }
        }
        /* hapus contoh dokumen jika tidak ada perubahan pada file */
      }

      var vm = this;
      RplWorkshopService.postRplWorkshop(formData)
        .then((response) => {
          loader.hide();
          vm.alertSuccess();
          vm.$router.push({
            path: "/sertifikasi/master-sertifikasi-rpl/master-rpl-lainnya",
          });
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
          vm.alertError(error.response.data.message);
          // vm.alertError();
        });
    },

    add(index) {
      this.formData.instrukturSertifikasiRplRequest.push({
        instruktur: "",
        idInstrukturRpl : "",
        modelMultiSelect : [],
        invalid_instruktur : false,
      });
      // comment console console.log(this.formData.instrukturSertifikasiRplRequest);
    },

    adds(index) {
      this.formData.dokumenPendukungSertifikasiRplRequest.push({
        contoh_dokumen: "",
        kode_dokumen: "",
        nama_dokumen: "",
        fileName: "",
        invalid_dokumen : false,
        idMasterDokumenPendukung : "",
      });
      // comment console console.log(this.formData.dokumenPendukungSertifikasiRplRequest);
    },

    addss(index) {
      this.formData.sertifikasiRplMataUjiRequest.push({
        mata_uji: "",
        idMasterMataUji : "",
        keterangan: "",
        nilai: "",
        graderSatu : '',
        graderDua : '',
        modelGraderSatu : [],
        modelGraderDua : [],
        invalid_mata_uji : false
      });
      // comment console console.log(this.formData.sertifikasiRplMataUjiRequest);
    },
    add_dok_sertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.push({
        idDokumenPendukung : "",
        idMasterDokumen : "",
        idMasterDokumenPendukung : "",
        invalid_dokumen : false,
      });
    },
    remove_dok_sertifikat(index) {
      this.formData.dokumenPersyaratanSertifikat.splice(index, 1);
    },
    remove(index) {
      this.formData.instrukturSertifikasiRplRequest.splice(index, 1);
    },

    removes(index) {
      this.formData.dokumenPendukungSertifikasiRplRequest.splice(index, 1);
    },

    removess(index) {
      this.formData.sertifikasiRplMataUjiRequest.splice(index, 1);
    },

    pilihInstruktur(value, k) {
      if(value.idInstrukturRpl != null) {
        this.formData.instrukturSertifikasiRplRequest[k].invalid_instruktur = false
      }

      for (
        let index = 0;
        index < this.formData.instrukturSertifikasiRplRequest.length;
        index++
      ) {
        var idInstrukturRpl = this.formData.instrukturSertifikasiRplRequest[index].idInstrukturRpl;
        var idSelectInstruktur = value.idInstrukturRpl;
        if (idInstrukturRpl == idSelectInstruktur) {
          this.alertError("Tidak Boleh Ada Instruktur Yang Sama");
          return false;
        }
      }

      this.formData.instrukturSertifikasiRplRequest[k].idInstrukturRpl = value.idInstrukturRpl;
    },

    getInstrukturRpl() {
      var vm = this;
      RplInstrukturService.getAll()
        .then((response) => {
          vm.instruktur = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>